





























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InlineEditor extends Vue {
	@Prop()
	private route?: any;

	@Prop()
	private value?: string;

	@Prop()
	private disableSave?: boolean;

	@Emit('save')
	public onSave(): (hasError: boolean) => void {
		return (hasError: boolean) => {
			this.saving = false;
			if (!hasError) {
				this.editing = false;
			}
		};
	}

	private editing = false;
	private saving = false;

	private save(): void {
		if (this.editing && !this.disableSave) {
			this.saving = true;
			this.onSave();
		} else this.editing = true;
	}
}
